import { abbreviations } from './abbreviations.js';

const validKeys = ['auto', '1', 'k', 'm', 'b', 't'];
const isKeyValid = (key) => validKeys.includes(key);
const isLanguageValid = (language) => Object.keys(abbreviations).includes(language);
const isDivisorValidForValue = (divisor, value) => Math.abs(value) >= divisor;

const humanizeWithAutomaticFactor = (value, locale, factors) => {
  const matchingFactors = Object.values(factors)
    .filter((factor) => isDivisorValidForValue(factor.divisor, value));
  const factor = matchingFactors[matchingFactors.length - 1] || factors[1];

  return {
    humanizedValue: value / factor.divisor,
    abbreviation: factor.name && abbreviations[locale][factor.name]
  };
};

const humanizeWithFixedFactor = (value, locale, factors, key) => {
  const fixedFactor = factors[key];
  const divisorForFixedFactor = fixedFactor.divisor;
  const factor = isDivisorValidForValue(divisorForFixedFactor, value) ? fixedFactor : factors[1];

  return {
    humanizedValue: value / factor.divisor,
    abbreviation: abbreviations[locale][factor.name]
  };
};

const getHumanizerFunction = (factors) => (value, unit, language) => {
  const locale = isLanguageValid(language) ? language : 'en';
  const key = isKeyValid(unit) ? unit : 'auto';

  return (key === 'auto') ?
    humanizeWithAutomaticFactor(value, locale, factors) :
    humanizeWithFixedFactor(value, locale, factors, key);
};

export const skipHumanize = (value) => ({
  humanizedValue: value,
  abbreviation: ''
});

export const humanizeNumber = getHumanizerFunction({
  1: { name: '', divisor: 1 },
  k: { name: 'thousand', divisor: 1000 },
  m: { name: 'million', divisor: 1000000 },
  b: { name: 'billion', divisor: 1000000000 },
  t: { name: 'trillion', divisor: 1000000000000 }
});

export const humanizeDigital = getHumanizerFunction({
  1: { name: 'byte', divisor: 1 },
  k: { name: 'kilobyte', divisor: 1000 },
  m: { name: 'megabyte', divisor: 1000000 },
  b: { name: 'gigabyte', divisor: 1000000000 },
  t: { name: 'terabyte', divisor: 1000000000000 }
});

export const humanizeDigitalBinary = getHumanizerFunction({
  1: { name: 'byte', divisor: 1 },
  k: { name: 'kibibyte', divisor: 1024 },
  m: { name: 'mebibyte', divisor: Math.pow(1024, 2) },
  b: { name: 'gibibyte', divisor: Math.pow(1024, 3) },
  t: { name: 'tebibyte', divisor: Math.pow(1024, 4) }
});
